import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Stack,
  CircularProgress,
  Alert,
  Chip,
  TextField,
  InputAdornment,
  Divider,
  useTheme,
  alpha,
} from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import {
  companyManagementUrl,
  salesManagement,
  setupManagementUrl,
  userManagementUrl,
} from "../../../config";
import SalesOrderForm from "./form";
import { useEffect, useState, useRef } from "react";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { tokens } from "../../../theme";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { format } from "date-fns";
import { gql } from "@apollo/client";
import usePermissions from "../../../data/RBAC/PermissionsHook";


const base_url = salesManagement.uri;

// ── GraphQL queries (unchanged) ───────────────────────────────────────────────
const SALE_ORDER_STATISTICS_QUERY = `
  query SaleOrderStatistics(
    $searchTerm: String
    $dateFrom: DateTime
    $dateTo: DateTime
    $branchId: Int
    $cancelled: Int
    $paymentMethodId: Int
    $isCredit: Int
    $createdBy: Int
    $isInvoiced: Int
    $isPaid: Int
    $companyId: Int
    $regionId: Int
  ) {
    saleOrderStatistics(
      functionparams: {
        searchTerm: $searchTerm
        dateFrom: $dateFrom
        dateTo: $dateTo
        branchId: $branchId
        cancelled: $cancelled
        paymentMethodId: $paymentMethodId
        isCredit: $isCredit
        createdBy: $createdBy
        isInvoiced: $isInvoiced
        isPaid: $isPaid
        companyId: $companyId
        regionId: $regionId
      }
    ) {
      activeOrders
      averageOutstanding
      averageSaleValue
      cancelledOrders
      cashSales
      creditSales
      invoicedOrders
      paidOrders
      partiallyPaidOrders
      totalOrders
      totalOutstanding
      totalSales
      uninvoicedOrders
      uniqueCustomers
      unpaidOrders
    }
  }
`;

const SEARCH_SALE_ORDERS_QUERY = `
  query SearchSaleOrders(
    $searchTerm: String
    $dateFrom: DateTime
    $dateTo: DateTime
    $branchId: Int
    $cancelled: Int
    $paymentMethodId: Int
    $isCredit: Int
    $createdBy: Int
    $isInvoiced: Int
    $isPaid: Int
    $companyId: Int
    $regionId: Int
    $pageNumber: Int
    $pageSize: Int
  ) {
    searchSaleOrdersFromView(
      functionparams: {
        companyId: $companyId
        branchId: $branchId
        paymentMethodId: $paymentMethodId
        createdBy: $createdBy
        cancelled: $cancelled
        dateFrom: $dateFrom
        dateTo: $dateTo
        isCredit: $isCredit
        isInvoiced: $isInvoiced
        isPaid: $isPaid
        pageNumber: $pageNumber
        pageSize: $pageSize
        regionId: $regionId
        searchTerm: $searchTerm
      }
    ) {
      branchId
      branchName
      cancelled
      companyId
      companyName
      createdBy
      createdDate
      currentPage
      customerBalance
      customerId
      customerName
      customerTypeId
      int
      isCredit
      isInvoiced
      isPaid
      modifiedBy
      outstanding
      pageSize
      paymentMethod
      paymentMethodId
      phoneNumber
      regionId
      reversed
      rowNum
      saleDate
      saleOrderId
      salesAgent
      totalAmount
      totalCount
      totalPages
      totalRows
      typeName
      updatedBy
      updatedDate
      paidDate
    }
  }
`;

const SALE_ORDERS_PAGINATED_QUERY = `
  query SaleOrdersPaginated($pageNumber: Int, $pageSize: Int) {
    saleOrdersPaginatedFunc(functionparams: { 
      pageNumber: $pageNumber, 
      pageSize: $pageSize 
    }) {
      branchId
      branchName
      cancelled
      companyId
      companyName
      createdBy
      createdDate
      currentPage
      customerBalance
      customerId
      customerName
      customerTypeId
      firstRecordInPage
      int
      isCredit
      isInvoiced
      isPaid
      lastRecordInPage
      modifiedBy
      outstanding
      pageSize
      paymentMethod
      paymentMethodId
      phoneNumber
      regionId
      reversed
      saleDate
      saleOrderId
      salesAgent
      totalAmount
      totalPages
      totalRecords
      typeName
      updatedBy
      updatedDate
      paidDate
    }
  }
`;

const ALL_COMPANY_BRANCHES_VIEW_QUERY = `
  query AllCompanyBranchesView {
    allBranchView {
      id
      branchName
      createdDate
      createdBy
      updatedBy
      companyId
      company
      regionId
      region
      isWarehouse
      location 
      building
      contacts
    }
  }
`;

const PAYMENT_METHODS_QUERY = `
  query PaymentMethods {
    paymentMethods {
      id
      methodName
      createdDate
      createdByName
      updatedDate
      updatedByName
      isActive
    }
  }
`;

const GET_USERS_QUERY = gql`
  query GetUsers {
    allUsersView {
      id
      firstName
      username
      lastName
      idno
      phone
      email
      isActive
      role
      roleGroup
      roleId
      genderId
      regionId
      branchId
      branchName
    }
  }
`;

const actions = {
  entity: "SalesOrder",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    inputObjectName: "",
    inputSubObjectName: null,
    Show_Button: false,
    permission: "ActivatePermission",
  },
  ViewSaleOrderItems: {
    key: "MARK_TASK_DONE",
    button_name: "View Order Items",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  ViewPaymentMethods: {
    key: "MARK_TASK_DONE",
    button_name: "View Payment Methods",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  Printreceipt: {
    key: "MARK_TASK_DONE",
    button_name: "Print",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Sales Order Details",
  },
  payments: {
    key: "MARK_TASK_DONE",
    button_name: "Make Payments",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  reversesaleOrder: {
    key: "Reverse Sale Order",
    button_name: "Reverse Transaction",
    ModuleNames: "reverseSaleOrder",
    inputObjectName: "reverseInventoryAfterSale",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: true,
  showCancelled: false,
};

function SalesOrderTable() {
  // ── Token & lock detection ────────────────────────────────────────────────
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  // Branch lock
  const tokenBranchId = parseInt(decodedToken?.BranchId);
  const isBranchLocked = !isNaN(tokenBranchId) && tokenBranchId > 0;

  // User/agent lock — lock to the logged-in user's own ID (createdBy)
  const tokenUserId = parseInt(decodedToken?.UserId || decodedToken?.Id || decodedToken?.sub);
  const isUserLocked = !isNaN(tokenUserId) && tokenUserId > 0 && isBranchLocked;
  const lockedUserName =
    [decodedToken?.FirstName, decodedToken?.LastName].filter(Boolean).join(" ") ||
    decodedToken?.Username ||
    decodedToken?.UserName ||
    `User #${tokenUserId}`;

  // ── State ─────────────────────────────────────────────────────────────────
  const [saleOrders, setSaleOrders] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingStats, setLoadingStats] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [error, setError] = useState("");

  // Pagination - 0-based for MUI DataGrid
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [rowCount, setRowCount] = useState(0);

  // Filters
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("all");
  const [creditStatusFilter, setCreditStatusFilter] = useState("all");
  const [invoiceStatusFilter, setInvoiceStatusFilter] = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [cancelledFilter, setCancelledFilter] = useState("all");
  const { hasPermission } = usePermissions();


  // ✅ Branch filter: locked to token branch when applicable
  const [branchFilter, setBranchFilter] = useState(
    isBranchLocked ? String(tokenBranchId) : "all"
  );

  const [paymentMethodFilter, setPaymentMethodFilter] = useState("all");

  // ✅ Sales agent filter: locked to token user ID when applicable
  const [salesAgentFilter, setSalesAgentFilter] = useState(
  isUserLocked && isBranchLocked ? tokenUserId : "all"
  );

  // Dropdown options
  const [branches, setBranches] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [salesAgents, setSalesAgents] = useState([]);

  const fetchRequestId = useRef(0);

  // Statistics
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalSales: 0,
    paidOrders: 0,
    partiallyPaidOrders: 0,   
    unpaidOrders: 0,
    creditSales: 0,
    cashSales: 0,
    totalOutstanding: 0,
    invoicedOrders: 0,
    uninvoicedOrders: 0,
    cancelledOrders: 0,
    activeOrders: 0,
    uniqueCustomers: 0,
    averageSaleValue: 0,
    averageOutstanding: 0,
  });

  // ✅ hasActiveFilters excludes locked dimensions from the user-visible count
  const hasActiveFilters =
    searchQuery ||
    paymentStatusFilter !== "all" ||
    creditStatusFilter !== "all" ||
    invoiceStatusFilter !== "all" ||
    dateFrom ||
    dateTo ||
    cancelledFilter !== "all" ||
    // Branch only counts as active filter when NOT locked
    (!isBranchLocked && branchFilter !== "all") ||
    paymentMethodFilter !== "all" ||
    // Agent only counts as active filter when NOT locked
    (!isUserLocked && salesAgentFilter !== "all");

  // MUI theme
  const muiTheme = useTheme();
  const colors = tokens(muiTheme.palette.mode);
  const isDark = muiTheme.palette.mode === "dark";

  const theme = {
    primary: isDark ? colors.blueAccent[400] : "#1976D2",
    secondary: isDark ? colors.blueAccent[500] : "#0288D1",
    success: "#4CAF50",
    warning: "#FF9800",
    error: "#F44336",
    info: isDark ? colors.blueAccent[300] : "#2196F3",
    purple: "#9C27B0",
    lightBg: isDark ? alpha(colors.blueAccent[400], 0.15) : "#E3F2FD",
    cardBg: isDark ? colors.primary[400] : "#FFFFFF",
    pageBg: isDark ? colors.primary[500] : "#F5F7FA",
    lockedBg: isDark ? alpha(colors.blueAccent[400], 0.08) : "#F0F7FF",
    iconBadgeGreen: isDark ? alpha("#4CAF50", 0.15) : "#E8F5E9",
    iconBadgeBlue: isDark ? alpha(colors.blueAccent[400], 0.15) : "#E3F2FD",
    iconBadgeRed: isDark ? alpha("#F44336", 0.15) : "#FFEBEE",
    iconBadgeOrange: isDark ? alpha("#FF9800", 0.15) : "#FFF3E0",
    iconBadgePurple: isDark ? alpha("#9C27B0", 0.15) : "#F3E5F5",
  };

  const ignore = [
    "isActive", "companyId", "cancelled", "customerBalance",
    "customerId", "createdBy", "saleOrderId", "updatedBy",
    "paymentMethodId", "CreatedBy", "UpdatedBy", "createdDate",
    "modifiedBy", "updatedDate", "phoneNumber",
  ];

  const ignoreShowMore = [
    "isActive", "companyId", "cancelled", "customerBalance",
    "customerId", "createdBy", "saleOrderId", "updatedBy",
    "paymentMethodId", "CreatedBy", "UpdatedBy", "branchId",
  ];

  const unignoredIds = ["saleOrderId", "isPaid"];

  // ── Filter options fetch ──────────────────────────────────────────────────
  const fetchFilterOptions = async () => {
    try {
      setLoadingFilters(true);

     
        const branchesResponse = await graphqlQuery(
          ALL_COMPANY_BRANCHES_VIEW_QUERY,
          companyManagementUrl.uri
        );
        if (branchesResponse) {
          let branchesData = [];
          if (Array.isArray(branchesResponse) && branchesResponse.length > 0) {
            if (Array.isArray(branchesResponse[0])) {
              branchesData = branchesResponse[0];
            } else if (branchesResponse[0]?.id) {
              branchesData = branchesResponse;
            }
          } else if (branchesResponse?.data?.allBranchView) {
            branchesData = branchesResponse.data.allBranchView;
          }
          const formattedBranches = branchesData
            .filter((b) => b.isActive !== false)
            .map((b) => ({ id: b.id, name: b.branchName }))
            .sort((a, b) => a.name.localeCompare(b.name));
          setBranches(formattedBranches);
        }
      

      // Payment methods (always fetch)
      const paymentMethodsResponse = await graphqlQuery(
        PAYMENT_METHODS_QUERY,
        setupManagementUrl.uri
      );
      if (paymentMethodsResponse) {
        let paymentMethodsData = [];
        if (Array.isArray(paymentMethodsResponse)) {
          paymentMethodsData = paymentMethodsResponse;
        } else if (paymentMethodsResponse?.data?.paymentMethods) {
          paymentMethodsData = paymentMethodsResponse.data.paymentMethods;
        } else if (paymentMethodsResponse?.paymentMethods) {
          paymentMethodsData = paymentMethodsResponse.paymentMethods;
        } else if (paymentMethodsResponse[0]?.paymentMethods) {
          paymentMethodsData = paymentMethodsResponse[0].paymentMethods;
        }
        const formattedPaymentMethods = paymentMethodsData
          .filter((m) => m.isActive !== false)
          .map((m) => ({ id: m.id, name: m.methodName }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setPaymentMethods(formattedPaymentMethods);
      }

     
        const usersResponse = await graphqlQuery(
          GET_USERS_QUERY.loc.source.body,
          userManagementUrl.uri
        );
        if (usersResponse) {
          let usersData = [];
          if (Array.isArray(usersResponse)) {
            usersData = usersResponse;
          } else if (usersResponse?.data?.allUsersView) {
            usersData = usersResponse.data.allUsersView;
          } else if (usersResponse?.allUsersView) {
            usersData = usersResponse.allUsersView;
          } else if (usersResponse[0]?.allUsersView) {
            usersData = usersResponse[0].allUsersView;
          }
          const formattedUsers = usersData
            .filter((u) => u.isActive !== false)
            .map((u) => ({
              id: u.id,
              name:
                `${u.firstName || ""} ${u.lastName || ""}`.trim() ||
                u.username ||
                `User ${u.id}`,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
          setSalesAgents(formattedUsers);
        }
      
    } catch (error) {
      console.error("Error fetching filter options:", error);
    } finally {
      setLoadingFilters(false);
    }
  };

  // ── Shared variables builder — always injects locked values ───────────────
  const getSelectedBranchId = () => {
    return branchFilter !== "all"
      ? branches.find((b) => b.name === branchFilter)?.id || null
      : null;
  };

  const getSelectedPaymentMethodId = () =>
    paymentMethodFilter !== "all"
      ? paymentMethods.find((pm) => pm.name === paymentMethodFilter)?.id || null
      : null;

  const getSelectedSalesAgentId = () => {
    return salesAgentFilter !== "all"
      ? isNaN(parseInt(salesAgentFilter))
        ? salesAgentFilter
        : parseInt(salesAgentFilter)
      : null;
  };

  const getSharedFilterVariables = () => ({
    searchTerm: searchQuery || null,
    dateFrom: dateFrom ? `${dateFrom}T00:00:00.000` : null,
    dateTo: dateTo
      ? `${dateTo}T23:59:59.999`
      : dateFrom
      ? `${new Date().toLocaleDateString("en-CA")}T23:59:59.999`
      : null,
    cancelled:
      cancelledFilter !== "all" ? (cancelledFilter === "true" ? 1 : 0) : null,
    isCredit:
      creditStatusFilter !== "all"
        ? creditStatusFilter === "true" ? 1 : 0
        : null,
    isInvoiced:
      invoiceStatusFilter !== "all"
        ? invoiceStatusFilter === "true" ? 1 : 0
        : null,
    isPaid:
      paymentStatusFilter === "all"
        ? null
        : paymentStatusFilter === "true"
        ? 1
        : paymentStatusFilter === "partial"
        ? 2
        : 0,
    companyId: companyId || null,
    regionId: null,
    branchId: getSelectedBranchId(),
    paymentMethodId: getSelectedPaymentMethodId(),
    createdBy: getSelectedSalesAgentId(),
  });

const lockedBranchName =
  isBranchLocked
      ? `${branches.find((b) => b.id === parseInt(tokenBranchId)) ?.name }`
      : branches.find((b) => b.id === parseInt(branchFilter) )?.name || "Unknown";

  // ── Statistics fetch ──────────────────────────────────────────────────────
  const fetchStatistics = async () => {
    try {
      setLoadingStats(true);
      const response = await graphqlQuery(
        SALE_ORDER_STATISTICS_QUERY,
        base_url,
        getSharedFilterVariables()
      );
      if (response) {
        const s = response?.[0];
        setStats({
          totalOrders: s.totalOrders || 0,
          totalSales: s.totalSales || 0,
          paidOrders: s.paidOrders || 0,
          partiallyPaidOrders: s.partiallyPaidOrders || 0,
          unpaidOrders: s.unpaidOrders || 0,
          creditSales: s.creditSales || 0,
          cashSales: s.cashSales || 0,
          totalOutstanding: s.totalOutstanding || 0,
          invoicedOrders: s.invoicedOrders || 0,
          uninvoicedOrders: s.uninvoicedOrders || 0,
          cancelledOrders: s.cancelledOrders || 0,
          activeOrders: s.activeOrders || 0,
          uniqueCustomers: s.uniqueCustomers || 0,
          averageSaleValue: s.averageSaleValue || 0,
          averageOutstanding: s.averageOutstanding || 0,
        });
        setTotalAmount(
          (s.totalSales || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    } catch (error) {
      console.error("Error fetching statistics:", error);
    } finally {
      setLoadingStats(false);
    }
  };

  // ── Main data fetch ───────────────────────────────────────────────────────
  const fetchSaleOrders = async () => {
    const requestId = ++fetchRequestId.current;
    setLoading(true);
    setError("");

    try {
      let response;
      let ordersData = [];
      let total = 0;

      // ✅ When user or branch is locked, we always have "active filters"
      // (the locked IDs are always passed), so use the search query path.
      const shouldUseSearchQuery =
        hasActiveFilters || isBranchLocked || isUserLocked;

      if (shouldUseSearchQuery) {
        const variables = {
          ...getSharedFilterVariables(),
          pageNumber: page + 1,
          pageSize,
        };

        response = await graphqlQuery(
          SEARCH_SALE_ORDERS_QUERY,
          base_url,
          variables
        );

        if (response?.data?.searchSaleOrdersFromView) {
          ordersData = response.data.searchSaleOrdersFromView;
        } else if (
          Array.isArray(response) &&
          response.length > 0 &&
          response[0].searchSaleOrdersFromView
        ) {
          ordersData = response[0].searchSaleOrdersFromView;
        } else if (Array.isArray(response)) {
          ordersData = response;
        } else if (response && Array.isArray(response.searchSaleOrdersFromView)) {
          ordersData = response.searchSaleOrdersFromView;
        }

        if (ordersData.length > 0) {
          total = ordersData[0].totalRows || ordersData.length;
        }
      } else {
        // Pure paginated query — no filters at all
        response = await graphqlQuery(SALE_ORDERS_PAGINATED_QUERY, base_url, {
          pageNumber: page + 1,
          pageSize,
        });

        if (response?.data?.saleOrdersPaginatedFunc) {
          ordersData = response.data.saleOrdersPaginatedFunc;
        } else if (
          Array.isArray(response) &&
          response.length > 0 &&
          response[0].saleOrdersPaginatedFunc
        ) {
          ordersData = response[0].saleOrdersPaginatedFunc;
        } else if (Array.isArray(response)) {
          ordersData = response;
        } else if (response && Array.isArray(response.saleOrdersPaginatedFunc)) {
          ordersData = response.saleOrdersPaginatedFunc;
        }

        if (ordersData.length > 0) {
          total = ordersData[0].totalRecords || ordersData.length;
        }
      }

      const formattedOrders = ordersData.map((order) => ({
        ...order,
        isPaid: typeof order.isPaid === 'boolean'
            ? (order.isPaid ? 1 : 0)   
            : order.isPaid,  
        isCredit: order.isCredit === 1 || order.isCredit === true,
        isInvoiced: order.isInvoiced === 1 || order.isInvoiced === true,
        cancelled: order.cancelled === 1 || order.cancelled === true,
        formattedSaleDate: order.saleDate
          ? format(new Date(order.saleDate), "yyyy-MM-dd")
          : "",
        formattedCreatedDate: order.createdDate
          ? format(new Date(order.createdDate), "yyyy-MM-dd")
          : "",
      }));

      if (requestId !== fetchRequestId.current) return;
      setSaleOrders(formattedOrders);
      setRowCount(total);
      setTotalCount(total);
    } catch (error) {
      if (requestId !== fetchRequestId.current) return;
      console.error("Error fetching sale orders:", error);
      setError("Failed to load sale orders. Please try again.");
    } finally {
      if (requestId === fetchRequestId.current) setLoading(false);
    }
  };

  // ── Effects ───────────────────────────────────────────────────────────────
  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchSaleOrders();
  }, [
    searchQuery, paymentStatusFilter, creditStatusFilter,
    invoiceStatusFilter, dateFrom, dateTo, cancelledFilter,
    branchFilter, paymentMethodFilter, salesAgentFilter,
    page, pageSize,
  ]);

  useEffect(() => {
    fetchStatistics();
  }, [
    searchQuery, paymentStatusFilter, creditStatusFilter,
    invoiceStatusFilter, dateFrom, dateTo, cancelledFilter,
    branchFilter, paymentMethodFilter, salesAgentFilter,
    branches, paymentMethods, salesAgents,
  ]);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleRefresh = () => {
    fetchSaleOrders();
    fetchStatistics();
    fetchFilterOptions();
  };

  // ✅ Clear filters — never resets locked dimensions
  const handleClearFilters = () => {
    setSearchQuery("");
    setPaymentStatusFilter("all");
    setCreditStatusFilter("all");
    setInvoiceStatusFilter("all");
    setDateFrom("");
    setDateTo("");
    setCancelledFilter("all");
    if (!isBranchLocked) setBranchFilter("all");
    setPaymentMethodFilter("all");
    if (!isUserLocked) setSalesAgentFilter("all");
    setPage(0);
  };

  const handlePageChange = (newPage) => setPage(newPage);
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ p: 3, bgcolor: theme.pageBg, minHeight: "100vh" }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1, flexWrap: "wrap", gap: 1 }}>
          <ShoppingBagIcon sx={{ fontSize: 32, color: theme.primary, mr: 1 }} />
          <Typography variant="h4" fontWeight="700" color={theme.primary}>
            Sales Order Management
          </Typography>
          {/* ✅ Locked user badge */}
          {isUserLocked && (
            <Chip
              icon={<PersonIcon sx={{ fontSize: "16px !important" }} />}
              label={`My Orders: ${lockedUserName}`}
              size="small"
              color="secondary"
              variant="filled"
              sx={{ fontWeight: 600 }}
            />
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {isBranchLocked && isUserLocked
            ? `Showing your orders for branch: ${lockedBranchName}`
            : isBranchLocked
            ? `Showing orders for branch: ${lockedBranchName}`
            : isUserLocked
            ? `Showing orders created by you: ${lockedUserName}`
            : "Track and manage all sales orders and customer transactions"}
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError("")}>
          {error}
        </Alert>
      )}
{hasPermission("SalesOrder", "ViewStatsPermission") && (
  <>
      {/* Statistics Cards - Row 1 */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            elevation={0}
            sx={{
              background: isDark
                ? `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[500]} 100%)`
                : `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
              color: "white",
              border: isDark
                ? `1px solid ${alpha(colors.blueAccent[400], 0.4)}`
                : "none",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                width: "150px",
                height: "150px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                top: "-50px",
                right: "-50px",
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <AttachMoneyIcon sx={{ fontSize: 28, mr: 1 }} />
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                  Total Sales
                </Typography>
                {loadingStats && (
                  <CircularProgress size={16} sx={{ ml: 1, color: "white" }} />
                )}
              </Box>
              <Typography variant="h4" fontWeight="700">
                KSh {totalAmount}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8, mt: 1 }}>
                {stats.totalOrders} orders • Avg: KSh{" "}
                {stats.averageSaleValue.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Payment Status Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Payment Status
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.success}>
                        {stats.paidOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Paid</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                      <Box>
                        <Typography variant="h5" fontWeight="700" color={theme.info}>
                          {stats.partiallyPaidOrders}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">Partial</Typography>
                      </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.warning}>
                        {stats.unpaidOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Unpaid</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgeGreen, p: 1.5, borderRadius: 2 }}>
                  <AccountBalanceWalletIcon sx={{ color: theme.success, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Credit vs Cash Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Sale Type
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.info}>
                        {stats.creditSales}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Credit</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.success}>
                        {stats.cashSales}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Cash</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgeBlue, p: 1.5, borderRadius: 2 }}>
                  <CreditCardIcon sx={{ color: theme.info, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Outstanding Balance Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Outstanding Balance
                  </Typography>
                  <Typography variant="h4" fontWeight="700" color={theme.error}>
                    KSh{" "}
                    {stats.totalOutstanding.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Avg: KSh{" "}
                    {stats.averageOutstanding.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgeRed, p: 1.5, borderRadius: 2 }}>
                  <PendingActionsIcon sx={{ color: theme.error, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Statistics Cards - Row 2 */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Invoice Status
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.success}>
                        {stats.invoicedOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Invoiced</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.warning}>
                        {stats.uninvoicedOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Uninvoiced</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgeOrange, p: 1.5, borderRadius: 2 }}>
                  <ReceiptIcon sx={{ color: theme.warning, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Order Status
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.success}>
                        {stats.activeOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Active</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                      <Typography variant="h5" fontWeight="700" color={theme.error}>
                        {stats.cancelledOrders}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Cancelled</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgePurple, p: 1.5, borderRadius: 2 }}>
                  <TrendingUpIcon sx={{ color: theme.purple, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card elevation={0} sx={{ bgcolor: theme.cardBg, height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontWeight="600">
                    Unique Customers
                  </Typography>
                  <Typography variant="h4" fontWeight="700" color={theme.primary}>
                    {stats.uniqueCustomers}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Total customer base
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: theme.iconBadgeBlue, p: 1.5, borderRadius: 2 }}>
                  <PeopleIcon sx={{ color: theme.primary, fontSize: 28 }} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
  </>
)}
      {/* Filters Section */}
      <Paper elevation={0} sx={{ p: 2.5, mb: 3, borderRadius: 2, bgcolor: theme.cardBg }}>
        <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <FilterListIcon sx={{ color: theme.primary }} />
          <Typography variant="h6" fontWeight="600">Filters</Typography>
          {loadingFilters && <CircularProgress size={16} sx={{ ml: 1 }} />}
          {hasActiveFilters && (
            <Chip
              label={`${[
                searchQuery && "Search",
                paymentStatusFilter !== "all" && "Payment",
                creditStatusFilter !== "all" && "Type",
                invoiceStatusFilter !== "all" && "Invoice",
                dateFrom && "From Date",
                dateTo && "To Date",
                cancelledFilter !== "all" && "Status",
                // ✅ Branch & agent excluded from count when locked
                !isBranchLocked && branchFilter !== "all" && "Branch",
                paymentMethodFilter !== "all" && "Method",
                !isUserLocked && salesAgentFilter !== "all" && "Agent",
              ].filter(Boolean).length} Active`}
              size="small"
              color="primary"
              onDelete={handleClearFilters}
            />
          )}
        </Box>

        <Grid container spacing={2} alignItems="center">
          {/* Search */}
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search customer, phone, order ID..."
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value); setPage(0); }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "text.secondary" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Branch — locked indicator OR dropdown */}
          {isBranchLocked ? (
            <Grid item xs={12} sm={6} md={1.5}>
              <Box
                sx={{
                  display: "flex", alignItems: "center", gap: 1,
                  px: 1.5, py: 1, border: "1px solid", borderColor: "divider",
                  borderRadius: 1, bgcolor: theme.lockedBg, height: 40,
                }}
              >
                <LockIcon sx={{ fontSize: 14, color: theme.primary }} />
                <StorefrontIcon sx={{ fontSize: 14, color: theme.primary }} />
                <Typography variant="body2" color={theme.primary} fontWeight="600" noWrap>
                  {lockedBranchName}
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={1.5}>
              <FormControl fullWidth size="small" disabled={loadingFilters}>
                <InputLabel>Branch</InputLabel>
                <Select
                  value={branchFilter}
                  label="Branch"
                  onChange={(e) => { setBranchFilter(e.target.value); setPage(0); }}
                >
                  <MenuItem value="all">All Branches</MenuItem>
                  {branches.map((branch) => (
                    <MenuItem key={branch.id} value={branch.name}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <StorefrontIcon sx={{ fontSize: 18, color: theme.primary }} />
                        {branch.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {/* Sales Agent — locked indicator OR dropdown */}
          {isUserLocked ? (
            <Grid item xs={12} sm={6} md={1.5}>
              <Box
                sx={{
                  display: "flex", alignItems: "center", gap: 1,
                  px: 1.5, py: 1, border: "1px solid", borderColor: "divider",
                  borderRadius: 1, bgcolor: theme.lockedBg, height: 40,
                }}
              >
                <LockIcon sx={{ fontSize: 14, color: "secondary.main" }} />
                <PersonIcon sx={{ fontSize: 14, color: "secondary.main" }} />
                <Typography variant="body2" color="secondary.main" fontWeight="600" noWrap>
                  {lockedUserName}
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={1.5}>
              <FormControl fullWidth size="small" disabled={loadingFilters}>
                <InputLabel>Sales Agent</InputLabel>
                <Select
                  value={salesAgentFilter}
                  label="Sales Agent"
                  onChange={(e) => { setSalesAgentFilter(e.target.value); setPage(0); }}
                >
                  <MenuItem value="all">All Agents</MenuItem>
                  {salesAgents.map((agent) => (
                    <MenuItem key={agent.id} value={agent.id}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <PeopleIcon sx={{ fontSize: 18, color: theme.secondary }} />
                        {agent.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {/* Payment Status */}
          <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Payment</InputLabel>
              <Select
                value={paymentStatusFilter}
                label="Payment"
                onChange={(e) => { setPaymentStatusFilter(e.target.value); setPage(0); }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="true">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CheckCircleIcon sx={{ fontSize: 18, color: theme.success }} />
                    Paid
                  </Box>
                </MenuItem>
                <MenuItem value="partial">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AccountBalanceWalletIcon sx={{ fontSize: 18, color: theme.info }} />
                    Partially Paid
                  </Box>
                </MenuItem>
                <MenuItem value="false">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PendingActionsIcon sx={{ fontSize: 18, color: theme.warning }} />
                    Unpaid
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Sale Type */}
          <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Sale Type</InputLabel>
              <Select
                value={creditStatusFilter}
                label="Sale Type"
                onChange={(e) => { setCreditStatusFilter(e.target.value); setPage(0); }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="true">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CreditCardIcon sx={{ fontSize: 18, color: theme.info }} />
                    Credit
                  </Box>
                </MenuItem>
                <MenuItem value="false">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AttachMoneyIcon sx={{ fontSize: 18, color: theme.success }} />
                    Cash
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Invoice */}
          <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Invoice</InputLabel>
              <Select
                value={invoiceStatusFilter}
                label="Invoice"
                onChange={(e) => { setInvoiceStatusFilter(e.target.value); setPage(0); }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="true">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CheckCircleIcon sx={{ fontSize: 18, color: theme.success }} />
                    Invoiced
                  </Box>
                </MenuItem>
                <MenuItem value="false">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PendingActionsIcon sx={{ fontSize: 18, color: theme.warning }} />
                    Uninvoiced
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Payment Method */}
          <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth size="small" disabled={loadingFilters}>
              <InputLabel>Payment Method</InputLabel>
              <Select
                value={paymentMethodFilter}
                label="Payment Method"
                onChange={(e) => { setPaymentMethodFilter(e.target.value); setPage(0); }}
              >
                <MenuItem value="all">All Methods</MenuItem>
                {paymentMethods.map((method) => (
                  <MenuItem key={method.id} value={method.name}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PaymentIcon sx={{ fontSize: 18, color: theme.secondary }} />
                      {method.name}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Status (Active/Cancelled) */}
          <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={cancelledFilter}
                label="Status"
                onChange={(e) => { setCancelledFilter(e.target.value); setPage(0); }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="false">Active</MenuItem>
                <MenuItem value="true">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>

          {/* From Date */}
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth size="small" type="date" label="From Date"
              InputLabelProps={{ shrink: true }} value={dateFrom}
              onChange={(e) => { setDateFrom(e.target.value); setPage(0); }}
            />
          </Grid>

          {/* To Date */}
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth size="small" type="date" label="To Date"
              InputLabelProps={{ shrink: true }} value={dateTo}
              onChange={(e) => { setDateTo(e.target.value); setPage(0); }}
            />
          </Grid>

          {/* Refresh */}
          <Grid item xs={12} md={0.5} sx={{ ml: "auto" }}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Tooltip title="Refresh data">
                <IconButton
                  onClick={handleRefresh}
                  disabled={loading || loadingStats || loadingFilters}
                  sx={{
                    bgcolor: theme.lightBg,
                    "&:hover": { bgcolor: theme.primary, color: "white" },
                  }}
                >
                  {loading || loadingStats || loadingFilters ? (
                    <CircularProgress size={20} />
                  ) : (
                    <RefreshIcon />
                  )}
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
        </Grid>

        {/* Active Filter Chips */}
        {hasActiveFilters && (
          <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
            {searchQuery && (
              <Chip
                label={`Search: "${searchQuery}"`} size="small"
                onDelete={() => { setSearchQuery(""); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {/* ✅ Branch chip hidden when locked */}
            {!isBranchLocked && branchFilter !== "all" && (
              <Chip
                label={`Branch: ${branchFilter}`} size="small"
                onDelete={() => { setBranchFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {/* ✅ Agent chip hidden when locked */}
            {!isUserLocked && salesAgentFilter !== "all" && (
              <Chip
                label={`Agent: ${salesAgents.find((a) => a.id === salesAgentFilter)?.name || salesAgentFilter}`}
                size="small"
                onDelete={() => { setSalesAgentFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {paymentStatusFilter !== "all" && (
              <Chip
                label={
                  `Payment:
                   ${
                  paymentStatusFilter === "true"
                  ? "Paid"
                  : paymentStatusFilter === "partial"
                  ? "Partially Paid"
                  : "Unpaid"                 
                }`}
                size="small"
                onDelete={() => { setPaymentStatusFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {creditStatusFilter !== "all" && (
              <Chip
                label={`Type: ${creditStatusFilter === "true" ? "Credit" : "Cash"}`}
                size="small"
                onDelete={() => { setCreditStatusFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {invoiceStatusFilter !== "all" && (
              <Chip
                label={`Invoice: ${invoiceStatusFilter === "true" ? "Invoiced" : "Uninvoiced"}`}
                size="small"
                onDelete={() => { setInvoiceStatusFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {paymentMethodFilter !== "all" && (
              <Chip
                label={`Method: ${paymentMethodFilter}`} size="small"
                onDelete={() => { setPaymentMethodFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {cancelledFilter !== "all" && (
              <Chip
                label={`Status: ${cancelledFilter === "false" ? "Active" : "Cancelled"}`}
                size="small"
                onDelete={() => { setCancelledFilter("all"); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {dateFrom && (
              <Chip
                label={`From: ${dateFrom}`} size="small"
                onDelete={() => { setDateFrom(""); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
            {dateTo && (
              <Chip
                label={`To: ${dateTo}`} size="small"
                onDelete={() => { setDateTo(""); setPage(0); }}
                color="primary" variant="outlined"
              />
            )}
          </Box>
        )}
      </Paper>

      {/* Table */}
      <Paper elevation={0} sx={{ borderRadius: 2, overflow: "hidden", bgcolor: theme.cardBg }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 }}>
            <CircularProgress />
          </Box>
        ) : (
          <DynamicTable
            title="Sales Orders"
            subtitle={`Showing ${saleOrders.length} of ${rowCount} orders${
              hasActiveFilters || isBranchLocked || isUserLocked ? " (filtered)" : ""
            }`}
            columns={[
              { field: "saleOrderId", headerName: "Order ID", width: 50 },
              { field: "customerName", headerName: "Customer", width: 100 },
              { field: "paymentMethod", headerName: "Payment Method", width: 100 },
              { field: "totalAmount", headerName: "Total Amount", width: 100 },
              { field: "outstanding", headerName: "Outstanding Amount", width: 100 },
              { field: "isPaid", headerName: "Is Paid", width: 100 },
              { field: "saleDate", headerName: "Sale Date", width: 100 },
              { field: "salesAgent", headerName: "Sale Agent", width: 100 },
              { field: "branchName", headerName: "Branch Name", width: 100 },
              { field: "reversed", headerName: "Is Reversed", width: 50 },
            ]}
            rows={saleOrders}
            rowCount={rowCount}
            page={page}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            paginationMode="server"
            pagination={true}
            ignoreFields={ignore}
            ignoreShowMore={ignoreShowMore}
            FormComponent={SalesOrderForm}
            query={
              hasActiveFilters || isBranchLocked || isUserLocked
                ? SEARCH_SALE_ORDERS_QUERY
                : SALE_ORDERS_PAGINATED_QUERY
            }
            base_url={base_url}
            actions={actions}
            onServerAction={handleRefresh}
            onAction={handleRefresh}
            unignoredIds={unignoredIds}
            getRowId={(row) => row.saleOrderId || row.id}
            checkboxSelection={false}
          />
        )}
      </Paper>
    </Box>
  );
}

export default SalesOrderTable;